<script setup>
import { computed } from 'vue'
import markdownit from 'markdown-it'

const md = markdownit()
const props = defineProps({
	content: {
		type: String,
		default: '',
	},
})
const html = computed(() => {
	if (!props.content) {
		return ''
	}

	return md
		.render(props.content)
		.replaceAll('<table>', '<div class="max-w-full min-w-0 overflow-x-auto"><table>')
		.replaceAll('</table>', '</table></div>')
})
</script>

<template>
	<div class="markdown min-w-0 max-w-full" v-html="html" />
</template>
